import { actions, selectors } from 'data'
import { connect, ConnectedProps } from 'react-redux'

import ChangeEmail from './template'

export type PropsType = ConnectedProps<typeof connector>

const mapStateToProps = (state) => ({
  isLoading: selectors.changeEmail.isLoading(state),
  newEmail: selectors.changeEmail.getNewEmail(state),
  oldEmail: selectors.changeEmail.getOldEmail(state)
})

const mapDispatchToProps = (dispatch) => ({
  onSubmit: () => {
    dispatch(actions.changeEmail.submit())
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(ChangeEmail)
